import {Vue} from '~/addiesaas'

// Components to list multiple products of a type of category etc.
import ReShopProductFieldBookingSlotSelector from './booking-slot-selector'
import ReShopProductFieldProductSimpleSummary from './product-simple-summary'
Vue.component(ReShopProductFieldBookingSlotSelector.name, ReShopProductFieldBookingSlotSelector)
Vue.component(ReShopProductFieldProductSimpleSummary.name, ReShopProductFieldProductSimpleSummary)
